import React, { Fragment } from 'react'
import ListeProducteurs from 'src/components/ListeProducteurs'
import withStyles from 'react-jss'
import styles from './PageRegionDep.styles'
import TopBar from 'src/components/top_bar/TopBar'
import { Col, Grid, Row } from 'react-bootstrap'
import Footer from 'src/components/footer'
import MapProducersInZone from '../../components/MapProducersInZone'
import TopBarSearch from 'src/components/top_bar/TopBarSearch'
import { Helmet } from 'react-helmet'
import { getCategoryTitleFromUrlParams, getUrlValueFromValue } from 'src/utils'
import Titre1 from 'src/components/font/Titre1'
import routes from 'src/routing/routes'
import Breadcrumb from 'src/components/breadcrumb/Breadcrumb'
import { categoriesOptions, mapAd } from 'src/config/dataConf'
import responsiveComponent from 'src/hoc/responsiveComponent'
import PubContainer from '../../../../../components/PubContainer'
import useWindowWidth from '../../../../../hooks/useWindowWidth'
import { mapAdLgSmLimitSize, smBannerAd } from '../../../../../config/dataConf'

const PageRegionDep = ({
  classes,
  page,
  bounds,
  loading,
  isRegion,
  cities,
  region,
  department,
  category,
  isMobile,
  data
}) => {
  const urlValue = getUrlValueFromValue(category)
  const categoryTitle = getCategoryTitleFromUrlParams(urlValue)
  const windowWidth = useWindowWidth

  return (
    <Fragment>
      {!loading && (
        <Helmet>
          <title>
            {isRegion
              ? !categoryTitle || category === 'all'
                ? `Producteurs locaux ${region.name} : Vente directe producteur`
                : `${categoryTitle} ${region.name} : ${category} en vente directe producteur`
              : !categoryTitle || category === 'all'
              ? `Producteurs locaux ${department.name} (${department.inseeCode}) : Vente directe producteur`
              : `${categoryTitle} ${department.name} (${department.inseeCode}) : ${category} en vente directe producteur`}
          </title>
          <meta
            name='description'
            content={
              isRegion
                ? `${
                    category !== 'all' ? `${category} en v` : 'V'
                  }ente directe producteur en ${
                    region.name
                  } sur Acheter à la Source. Découvrez tous les producteurs proches de chez vous et profitez de leurs produits de qualité !`
                : `${
                    category !== 'all' ? `${category} en v` : 'V'
                  }ente directe producteur en ${department.name} (${
                    department.inseeCode
                  }) sur Acheter à la Source. Découvrez tous les producteurs proches de chez vous et profitez de leurs produits de qualité !`
            }
          />
        </Helmet>
      )}
      <div className={classes.wrapper}>
        <div className={classes.wrapperWithoutFooter}>
          <div className='visible-xs-block'>
            <TopBar />
          </div>

          <div className='hidden-xs'>
            <TopBarSearch bleu className={classes.topFix} />
            <div className={classes.paddingTop} />
          </div>
          <Grid fluid>
            <Row>
              <Col xs={12} sm={4}>
                {!loading && (
                  <>
                    <Breadcrumb
                      className={classes.breadcrumb}
                      items={[
                        { name: 'Accueil', to: routes.accueil },
                        {
                          name: categoryTitle,
                          to: routes.siteMap.replace(':category', urlValue)
                        },
                        {
                          name: isRegion ? region.name : department.regionName,
                          ...(isRegion
                            ? { active: true }
                            : {
                                to: routes.mapRegion
                                  .replace(
                                    ':inseeRegion',
                                    department.regionInseeCode
                                  )
                                  .replace(':category', urlValue)
                                  .replace(':page', '1')
                              })
                        },
                        ...(!isRegion
                          ? [{ name: department.name, active: true }]
                          : [])
                      ]}
                    />
                    <Titre1 className={classes.titreRecherche}>
                      {category !== 'all' ? (
                        <Fragment>
                          {category} <br />
                        </Fragment>
                      ) : (
                        ''
                      )}
                      Producteurs en vente directe -{' '}
                      {isRegion ? region.name : department.name}
                    </Titre1>
                  </>
                )}

                <ListeProducteurs page={page} data={data} loading={loading} />

                {!loading && (
                  <div className={classes.cities}>
                    <Titre1>Producteurs en vente directe par villes</Titre1>

                    {cities.map((city, index) => (
                      <Fragment key={city.id}>
                        {index > 0 && ', '}
                        <a
                          href={routes.mapVille
                            .replace(':category', urlValue)
                            .replace(':idVille', city.id)}
                        >
                          {categoryTitle} {city.name}
                        </a>
                      </Fragment>
                    ))}
                  </div>
                )}
              </Col>

              {!isMobile ? (
                windowWidth > mapAdLgSmLimitSize ? (
                  <PubContainer
                    className={classes.pub}
                    scriptPubCore={smBannerAd}
                  />
                ) : (
                  <PubContainer className={classes.pub} scriptPubCore={mapAd} />
                )
              ) : null}

              {!loading && bounds && data && (
                <MapProducersInZone
                  bounds={bounds}
                  producers={data.producers}
                />
              )}
            </Row>
          </Grid>
        </div>
        <Grid fluid>
          <Row>
            <Col xs={12} sm={4} className={classes.noPadding}>
              <Footer />
            </Col>
          </Row>
        </Grid>
      </div>
    </Fragment>
  )
}

export default responsiveComponent(withStyles(styles)(PageRegionDep))
